import { gql, useQuery, useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';

const GET_LIST = gql`
  query($sn: String, $lp: String) {
        getReviews(searchInput: {sn: $sn, lp: $lp}) {
        items {
            name,
            rating,
            pros,
            cons,
            description
        }
        url
      }
  }
`;

function useReviews(props) {

    const sn = props.item ? props.item.sn : null;

    let {loading, error, data} = useQuery(GET_LIST, {variables: {sn: sn, lp: props.lp}});


    return data ? data.getReviews : null;
}

export default useReviews;
